// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playerList .el-pagination[data-v-5d09182a] {\n  margin-top: 20px;\n  text-align: right;\n}\n.playerList .search[data-v-5d09182a] {\n  margin: 20px 0;\n}\n", ""]);
// Exports
module.exports = exports;
